<template>
  <div class="splash-screen-animation">
    <img
      src="/lottie/splash-screen.gif"
      class="splash-screen-animation-animation"
    />
  </div>
</template>
<script setup lang="ts"></script>

<style scoped lang="scss">
.splash-screen-animation {
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
  z-index: 100;
  background: var(--color-brand-03);

  &-animation {
    width: 100%;
  }
}
</style>
